// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2-uSO","title":"FrontImage_title__iry2I"};